import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import Table from './Table';
import { isArrayEmpty } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import Grouped from './Grouped';
import filterSubs from '../actions/filterSubs';

const Subscriptions = ({ subscriptions, filters, lang, selectedAccount }) => {
  const dataToShow = useMemo(
    () => filterSubs({ subscriptions, filters, lang, selectedAccount }),
    [subscriptions, filters, lang, selectedAccount]
  );

  return isArrayEmpty(filters.groupedBy) ? (
    <Table data={dataToShow} />
  ) : (
    <Grouped data={dataToShow} />
  );
};

const mapStatesToProps = ({ subscriptionsImproved, auth }) => {
  return {
    subscriptions: subscriptionsImproved.subscriptions,
    filters: subscriptionsImproved.filters,
    lang: Optional(auth.lang).or('default'),
    selectedAccount: subscriptionsImproved.selectedAccount
  };
};

export default connect(mapStatesToProps)(Subscriptions);
